
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}

const _spaOnlyPageStub = { render: () => null };
import { default as loginwXSbd5bv3_0CNxov15g0PgNNcqxndcE3LH9clRnfVv0Meta } from "/var/www/html/app/pages/login.vue?macro=true";
import { default as _91slug_93_45cakesxCKQ6DTx1qg6ojeN7z3Lgn_0ofJP3Ka_Nn4QX91611YMeta } from "/var/www/html/app/pages/[slug]-cakes.vue?macro=true";
export default [
  {
    name: "admin-products-create",
    path: "/admin/products/create",
    meta: {"layout":"admin","middleware":"auth"},
    component: import.meta.client ? () => import("/var/www/html/app/pages/admin/products/create.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "admin-products-id-edit-variations",
    path: "/admin/products/:id()/edit/variations",
    meta: {"layout":"admin","middleware":["auth"]},
    component: import.meta.client ? () => import("/var/www/html/app/pages/admin/products/[id]/edit/variations.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "admin-galleries-id-edit",
    path: "/admin/galleries/:id()/edit",
    meta: {"layout":"admin","middleware":["auth"]},
    component: import.meta.client ? () => import("/var/www/html/app/pages/admin/galleries/[id]/edit.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "admin-products-id-edit",
    path: "/admin/products/:id()/edit",
    meta: {"layout":"admin","middleware":["auth"]},
    component: import.meta.client ? () => import("/var/www/html/app/pages/admin/products/[id]/edit/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "admin-products-id",
    path: "/admin/products/:id()",
    meta: {"layout":"admin","middleware":["auth"]},
    component: import.meta.client ? () => import("/var/www/html/app/pages/admin/products/[id]/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "password-reset-token",
    path: "/password/reset/:token()",
    component: () => import("/var/www/html/app/pages/password/reset/[token].vue")
  },
  {
    name: "admin-galleries",
    path: "/admin/galleries",
    meta: {"layout":"admin","middleware":"auth"},
    component: import.meta.client ? () => import("/var/www/html/app/pages/admin/galleries/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "admin-ingredients",
    path: "/admin/ingredients",
    meta: {"layout":"admin","middleware":"auth"},
    component: import.meta.client ? () => import("/var/www/html/app/pages/admin/ingredients/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "admin-packagings",
    path: "/admin/packagings",
    meta: {"layout":"admin","middleware":"auth"},
    component: import.meta.client ? () => import("/var/www/html/app/pages/admin/packagings/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "admin-products",
    path: "/admin/products",
    meta: {"layout":"admin","middleware":"auth"},
    component: import.meta.client ? () => import("/var/www/html/app/pages/admin/products/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "admin-settings",
    path: "/admin/settings",
    meta: {"layout":"admin","middleware":"auth"},
    component: import.meta.client ? () => import("/var/www/html/app/pages/admin/settings.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "admin-units",
    path: "/admin/units",
    meta: {"layout":"admin","middleware":"auth"},
    component: import.meta.client ? () => import("/var/www/html/app/pages/admin/units/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "galleries-slug",
    path: "/galleries/:slug()",
    component: () => import("/var/www/html/app/pages/galleries/[slug].vue")
  },
  {
    name: "products-slug",
    path: "/products/:slug()",
    component: () => import("/var/www/html/app/pages/products/[slug].vue")
  },
  {
    name: "admin-all",
    path: "/admin/:all(.*)*",
    meta: {"layout":"admin","middleware":"auth"},
    component: import.meta.client ? () => import("/var/www/html/app/pages/admin/[...all].vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/var/www/html/app/pages/about.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: {"layout":"admin","middleware":"auth"},
    component: import.meta.client ? () => import("/var/www/html/app/pages/admin/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "birthday-cakes",
    path: "/birthday-cakes",
    component: () => import("/var/www/html/app/pages/birthday-cakes.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/var/www/html/app/pages/contact.vue")
  },
  {
    name: "cookie-policy",
    path: "/cookie-policy",
    component: () => import("/var/www/html/app/pages/cookie-policy.vue")
  },
  {
    name: "cupcakes",
    path: "/cupcakes",
    component: () => import("/var/www/html/app/pages/cupcakes.vue")
  },
  {
    name: "delivery",
    path: "/delivery",
    component: () => import("/var/www/html/app/pages/delivery.vue")
  },
  {
    name: "faqs",
    path: "/faqs",
    component: () => import("/var/www/html/app/pages/faqs.vue")
  },
  {
    name: "galleries",
    path: "/galleries",
    component: () => import("/var/www/html/app/pages/galleries/index.vue")
  },
  {
    name: "hungarian-cakes",
    path: "/hungarian-cakes",
    component: () => import("/var/www/html/app/pages/hungarian-cakes.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginwXSbd5bv3_0CNxov15g0PgNNcqxndcE3LH9clRnfVv0Meta || {},
    component: () => import("/var/www/html/app/pages/login.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/var/www/html/app/pages/products/index.vue")
  },
  {
    name: "wedding-cakes",
    path: "/wedding-cakes",
    component: () => import("/var/www/html/app/pages/wedding-cakes.vue")
  },
  {
    name: "slug-cakes",
    path: "/:slug()-cakes",
    meta: _91slug_93_45cakesxCKQ6DTx1qg6ojeN7z3Lgn_0ofJP3Ka_Nn4QX91611YMeta || {},
    component: () => import("/var/www/html/app/pages/[slug]-cakes.vue")
  },
  {
    name: "all",
    path: "/:all(.*)*",
    component: () => import("/var/www/html/app/pages/[...all].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/html/app/pages/index.vue")
  }
]